module.exports = __webpack_public_path__ + "img/logo-survey.5c6e1d58.png";